import React from 'react';
import './ErrorHandle.css'
import i18n from '../../../i18n';

export const SomethingWentWrong = () => (
  <div className='error-handle-no-data'>{i18n.t('ErrorHandling')}</div>
);

